import React from 'react';

const CoFactorsSymbol = props => {
	return (
		<>
			<div className="co-factors-symbol">A({props.children})</div>
		</>
	);
};

export default CoFactorsSymbol;
